import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Rótulo de campo. Sempre com `htmlFor` apontando para o `id` do controle — sem isso
 * o clique no texto não foca o campo e o leitor de tela não associa os dois.
 */
export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('text-sm font-medium leading-none text-foreground', className)}
      {...props}
    />
  ),
);

Label.displayName = 'Label';
